<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0428 19.9042C14.1917 19.9659 14.355 20 14.5263 20C14.6976 20 14.8609 19.9659 15.0098 19.9042C15.1588 19.8425 15.2984 19.7511 15.4195 19.63L19.63 15.4195C20.1233 14.9262 20.1233 14.1264 19.63 13.6331C19.1367 13.1398 18.3369 13.1398 17.8437 13.6331L15.7895 15.6873L15.7895 8.63158C15.7895 7.40321 15.3015 6.22515 14.4329 5.35656C13.5643 4.48797 12.3863 4 11.1579 4L5.26316 4C4.56554 4 4 4.56553 4 5.26316C4 5.96078 4.56554 6.52631 5.26316 6.52631L11.1579 6.52631C11.7162 6.52631 12.2517 6.74812 12.6465 7.14293C13.0414 7.53775 13.2632 8.07323 13.2632 8.63158L13.2632 15.6873L11.209 13.6331C10.7157 13.1398 9.9159 13.1398 9.4226 13.6331C8.92931 14.1264 8.92931 14.9262 9.4226 15.4195L13.6331 19.63C13.7542 19.7511 13.8938 19.8425 14.0428 19.9042Z"
    />
  </svg>
</template>
